import { isUndefined } from 'lodash-es';
import type { FieldValues } from 'react-hook-form';

import type { Document, WorkflowStepFormFieldBlock } from '../../types';
import { getFieldValuesFromFormBlocks } from './getFieldValuesFromFormBlocks';

export const getFieldValuesArrayFromFormBlocks = (
  formFieldBlocks: WorkflowStepFormFieldBlock[],
  documents: Document<any>[] | undefined,
): FieldValues[] => {
  if (isUndefined(documents)) {
    return [];
  }

  const fieldValuesArray: FieldValues[] = [];

  documents.forEach((_document) => {
    const documentFieldValues = getFieldValuesFromFormBlocks(
      formFieldBlocks,
      _document,
    );
    fieldValuesArray.push(documentFieldValues);
  });

  return fieldValuesArray;
};
